var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Collection Info "),_c('v-spacer'),_c('v-btn',{attrs:{"color":"success","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.refresh.apply(null, arguments)}}},[_c('v-icon',[_vm._v("mdi-refresh")])],1)],1),_c('v-card-text',[_c('pre',[_vm._v(_vm._s(_vm.collection)+"\n      ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }